const upcomingEventElementList = document.querySelectorAll('.upcoming-events');

if (upcomingEventElementList.length !== 0) {
    for (let x = 0; x < upcomingEventElementList.length; x++) {
        const hasResults =
            upcomingEventElementList[x].querySelector('.no-results-found');

        if (hasResults) {
            upcomingEventElementList[x].style.display = 'none';
        }
    }
}
